import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components/macro";

import { createSearchParams, Navigate, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../store";
import userSlice from "../../../reducer/user";
import Modal from "../../../components/Modal";
import { InfoType, settingUsertype } from "../../../reducer/userpayloadtypes";
import axios from "axios";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducer";
import { NoticeListType } from "../../../reducer/postpayloadtypes";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);
dayjs.locale("ko");

const Container = styled.div``;

export const PageTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #dddddd;
  background-color: #fff;
  padding: 15px 0;
  font-size: 1.13em;
  position: relative;
  .pagetit {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 2.5vw;
    font-family: "spoqa500";
  }
  .move-btn {
    position: absolute;
    height: 100%;
    top: 0;
    right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    & img {
      cursor: pointer;
      width: 100%;
    }
  }

  @media screen and (min-width: 1050px) {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #dddddd;
    background-color: #fff;
    padding: 20px 0;
    font-size: 1.4em;
    position: relative;

    .move-btn {
      position: absolute;
      width: 1.5%;
      height: 100%;
      top: 0;
      right: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      & img {
        cursor: pointer;
        width: 100%;
      }
    }
  }
`;

const FirstCon = styled.div`
  height: 86px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 10px;
`;

const FlexCon = styled.div`
  display: flex;
  padding: 0 30px;
  justify-content: space-between;

  div {
    display: flex;
    flex-direction: column;
    font-size: 16px;
  }

  .leftcon {
    display: flex;
    align-items: flex-start;
    padding: 10px 0px;

    div:first-child {
      font-size: 12px;
      color: #656565;
    }
  }

  .secondtxt {
    top: 30%;
    position: relative;
    font-size: 14px;
    color: #2a3a4b;
  }

  .profilecon {
    background-color: #73972c;
    border: 0.5px solid #73972c;
    width: 80px;
    height: 35px;
    color: white;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
`;

const NoticeList = () => {
  const navigate = useNavigate();

  const [notiList, setNotiList] = useState<NoticeListType[]>([]);
  useEffect(() => {
    const getNotiList = async () => {
      try {
        const response = await axios.get(`ifactory/api/notice`);

        setNotiList(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    getNotiList();
  }, []);

  const notiListN = notiList.filter((v) => v.memberCheckYn === "N");

  const Nid = notiListN.map((v) => v.memberNoticeId);

  useEffect(() => {
    const noticeChange = async () => {
      if (Nid.length >= 1) {
        try {
          const response = await axios.put(
            `ifactory/api/notice`,
            Nid
          );
        } catch (error) {
          console.error(error);
        }
      }
    };
    noticeChange();
  }, [Nid]);
  return (
    <Container>
      <PageTop>
        <p className="pagetit">알림</p>
        <p className="move-btn">
          <img
            src="./img/X.svg"
            onClick={() => {
              navigate(-1);
            }}
            alt="X"
          />
        </p>
      </PageTop>

      {notiList.map((notice) => {
        const posttime = dayjs(notice.regDate).format("MM월 DD일");
        const fromNow = dayjs(notice.regDate).fromNow();

        return (
          <FirstCon
            style={{
              background:
                notice.memberCheckYn === "N"
                  ? "rgba(255, 220, 195, 1)"
                  : "none",
            }}
          >
            <FlexCon>
              <div className="leftcon">
                <div>{fromNow} 알람</div>
                <div className="secondtxt">{notice.noticeComment}</div>
              </div>

              <div>{posttime}</div>
            </FlexCon>
          </FirstCon>
        );
      })}
    </Container>
  );
};

export default NoticeList;
